import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
    selector: 'app-hospitals',
    templateUrl: './hospitals.component.svg',
    styleUrls: ['./hospitals.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HospitalsComponent {}
